module.exports = __webpack_public_path__ + "static/media/boxes.7f30a657.svg";